import React, { useMemo } from "react";
import cn from "classnames";
import { useUI } from "../context";

const CheckIcon = () => (
  <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4766 0.648438C12.832 0.976562 12.832 1.55078 12.4766 1.87891L5.47656 8.87891C5.14844 9.23438 4.57422 9.23438 4.24609 8.87891L0.746094 5.37891C0.390625 5.05078 0.390625 4.47656 0.746094 4.14844C1.07422 3.79297 1.64844 3.79297 1.97656 4.14844L4.875 7.01953L11.2461 0.648438C11.5742 0.292969 12.1484 0.292969 12.4766 0.648438Z"
      fill="currentColor"
    />
  </svg>
);

const STEPS_ARR = ["Introduction", "Objectif", "Identification", "Données de contact"];

export const Steps = () => {
  const { activeStep, page_settings } = useUI();

  const STEPS_ARR = useMemo(
    () => [
      page_settings.step1.name,
      page_settings.step2.name,
      page_settings.step3.name,
      page_settings.step4.name,
    ],
    [page_settings]
  );

  return (
    <>
      <div className="py-4 pb-2.5 lg:hidden border border-b-1 border-gray-modern-300">
        <div className="container flex items-center gap-6">
          <div
            className="w-10 h-10 rounded-full flex justify-center items-center"
            style={{
              background: `radial-gradient(closest-side, white 85%, transparent 80% 100%), conic-gradient(#0077C0 ${
                25 * (activeStep + 1)
              }%, #DEDEDE 0)`,
            }}
          >
            <progress style={{ visibility: "hidden", height: 0, width: 0 }} />
            <p className="text-text-xs text-text-black">
              {activeStep > 3 ? activeStep : activeStep + 1}/4
            </p>
          </div>
          <p className="font-medium text-text-sm text-gray-modern-800">{STEPS_ARR[activeStep]}</p>
        </div>
      </div>
      <div className="hidden lg:block py-10">
        <div className="container flex items-center gap-2.5">
          {STEPS_ARR.map((item, index) => (
            <div
              key={index}
              className={cn("flex items-center gap-2.5 group", {
                active: index === activeStep,
                done: index < activeStep,
              })}
            >
              {index > 0 && (
                <div className="w-5 h-0.5 bg-gray-modern-300 group-[.active]:bg-primary-500"></div>
              )}

              <div className="w-8 h-8 rounded-full flex justify-center items-center outline outline-1 outline-offset-[-1px] outline-text-light text-text-lg group-[.active]:outline-primary-500 group-[.active]:bg-primary-500 group-[.active]:text-white group-[.done]:bg-success-500 group-[.done]:outline-success-500 group-[.done]:text-success-900">
                <div className="font-bold text-text-sm group-[.done]:hidden">{index + 1}</div>
                <div className="hidden group-[.done]:block">
                  <CheckIcon />
                </div>
              </div>

              <div className="text-text-sm text-text-light group-[.active]:font-semibold group-[.active]:text-text-black">
                {item}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
